import { Link } from "react-router-dom";
import "../css/HomePage.css";

const HomePage = () => {
    return (
        <>
            <main className="tamcare-home">
                <header className="tamcare-hero" id="gioi-thieu">
                    <div className="tamcare-container tamcare-hero-grid">
                        <div className="tamcare-hero-copy tamcare-fade-up">
                            <span className="tamcare-eyebrow">TamCare - Vì sức khỏe người cao tuổi</span>
                            <h1>
                                Chăm sóc sức khỏe<br />
                                <span>với trọn niềm yêu thương</span>
                            </h1>
                            <p>
                                Nền tảng công nghệ dành riêng cho người cao tuổi, mang lại sự an tâm tuyệt đối qua việc theo dõi y tế thông minh.
                            </p>
                            <div className="tamcare-hero-actions">
                                <Link className="tamcare-btn tamcare-btn-primary" to="/register">
                                    Bắt đầu ngay <i className="fa-solid fa-arrow-right"></i>
                                </Link>
                                <a className="tamcare-btn tamcare-btn-ghost" href="#tinh-nang">
                                    Khám phá tính năng
                                </a>
                            </div>
                        </div>

                        <div className="tamcare-hero-visual tamcare-fade-up">
                            <img
                                src="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                                alt="Chăm sóc người cao tuổi"
                            />
                        </div>
                    </div>
                </header>

                <section className="tamcare-container tamcare-feature-grid" id="tinh-nang">
                    <article className="tamcare-feature-card tamcare-fade-up">
                        <div className="tamcare-feature-icon">
                            <i className="fa-solid fa-person-cane"></i>
                        </div>
                        <h3>Tự chủ sức khỏe</h3>
                        <p>Giúp người cao tuổi chủ động hơn trong việc theo dõi và chăm sóc sức khỏe hàng ngày một cách dễ dàng.</p>
                    </article>
                    <article className="tamcare-feature-card tamcare-fade-up">
                        <div className="tamcare-feature-icon">
                            <i className="fa-solid fa-heart-pulse"></i>
                        </div>
                        <h3>Theo dõi liên tục</h3>
                        <p>Giám sát chỉ số sức khỏe 24/7, phát hiện sớm các dấu hiệu bất thường để hỗ trợ kịp thời.</p>
                    </article>
                    <article className="tamcare-feature-card tamcare-fade-up">
                        <div className="tamcare-feature-icon">
                            <i className="fa-solid fa-pills"></i>
                        </div>
                        <h3>Nhắc nhở y tế</h3>
                        <p>Hỗ trợ quản lý lịch trình và tự động nhắc nhở uống thuốc đúng giờ, đúng liều lượng mỗi ngày.</p>
                    </article>
                </section>

                <section className="tamcare-container tamcare-mission" id="sứ-mệnh">
                    <div className="tamcare-mission-content tamcare-fade-up">
                        <span className="tamcare-section-label">Sứ mệnh</span>
                        <h2>Sứ mệnh của TamCare</h2>
                        <p>
                            Chúng tôi tin rằng công nghệ chỉ thực sự có ý nghĩa khi nó mang lại hơi ấm và sự an tâm.
                            TamCare là cầu nối yêu thương giữa các thế hệ trong gia đình.
                        </p>
                    </div>
                </section>
            </main>
        </>
    )
}
export default HomePage;